import React from 'react';

export const StepSeparatorTestId = 'StepSeparator-content';

const StepSeparator: React.FC = () => {
  return (
    <div data-testid={StepSeparatorTestId}>
      <svg
        className="mt-1.5"
        width="7"
        height="11"
        viewBox="0 0 7 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>steps separator</title>
        <path
          d="M0.5 9.37213L4.37219 5.49994L0.5 1.62775L1.68536 0.442386L6.74292 5.49994L1.68536 10.5575L0.5 9.37213Z"
          fill="#9CA3AF"
        />
      </svg>
    </div>
  );
};

export default StepSeparator;
